//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'RomanIndex',
  data() {
    return {
      form: {
        he4: '',
        ca125: '',
      },
      hasScore: false,
      disabled: false,
      text1: '',
      text2: ''
    }
  },
  created() {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {
        let result1 = -12.0 + 2.38 * Math.log(form.he4) + 0.0626 * Math.log(form.ca125)
        let result2 = -8.09 + 1.04 * Math.log(form.he4) + 0.732 * Math.log(form.ca125)
        console.log(result1, result2);
        self.text1 = ((Math.exp(result1) / (1 + Math.exp(result1))) * 100).toFixed(1)
        self.text2 = ((Math.exp(result2) / (1 + Math.exp(result2))) * 100).toFixed(1)
        self.hasScore = true
        return String(self.text1, self.text2)
      }
    }
  },


}



// WEBPACK FOOTER //
// ./src/pages/formulas/NewFormulas/RomanIndex.vue